import { render, staticRenderFns } from "./ReferenceCard.vue?vue&type=template&id=2401a7fb&scoped=true&"
import script from "./ReferenceCard.vue?vue&type=script&lang=js&"
export * from "./ReferenceCard.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceCard.vue?vue&type=style&index=0&id=2401a7fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2401a7fb",
  null
  
)

export default component.exports